var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.content
  }, [_c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "tablet",
      fn: function fn() {
        return [_c('header', {
          class: _vm.$style.header
        }, [_c('nav', {
          class: _vm.$style.navigation,
          on: {
            "click": function click($event) {
              return _vm.$router.go(-1);
            }
          }
        }, [_c('base-icon', {
          attrs: {
            "name": "arrows_arrow-left"
          }
        })], 1), _c('div', {
          class: _vm.$style.title,
          domProps: {
            "textContent": _vm._s(_vm.$t('restore.password.title'))
          }
        })])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('header', {
          class: _vm.$style.header
        }, [_c('navigate-button', {
          directives: [{
            name: "absolute",
            rawName: "v-absolute"
          }, {
            name: "left",
            rawName: "v-left",
            value: -80,
            expression: "-80"
          }],
          attrs: {
            "variant": "primary"
          },
          on: {
            "navigate": function navigate($event) {
              return _vm.$router.go(-1);
            }
          }
        }), _c('div', {
          class: _vm.$style.title,
          domProps: {
            "textContent": _vm._s(_vm.$t('restore.password.title'))
          }
        })], 1)];
      },
      proxy: true
    }])
  }), _c('section', {
    class: _vm.$style.form
  }, [_c('labeled-input', {
    attrs: {
      "label": _vm.getFieldLabel(_vm.$v.form.email, 'registration.email.input.label'),
      "placeholder": _vm.$t('registration.email.input.placeholder'),
      "disabled": _vm.loading,
      "error": _vm.$v.form.email.$error
    },
    on: {
      "focus": _vm.$v.form.email.$reset,
      "blur": _vm.$v.form.email.$touch
    },
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  }), _c('div', {
    class: _vm.$style.submit
  }, [_c('simple-button', {
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isInvalidForm
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('restore.password.submit')) + " ")])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }